import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Включить/выключить показ портфеля в рейтинге комьюнити
export async function patchPortfolioVisibility(isPublic) {
  const response = await fetchWithAuth(`${backendUrl}/api/portfolios/visibility/`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ is_public: isPublic }),
  });
  if (!response.ok) {
    throw new Error(`Не удалось сохранить настройку публичности: HTTP ${response.status}`);
  }
  return response.json();
}
